// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"630":"565725c1","940":"9cfb7392"}[chunkId] + ".chunk.js";
};